import { ReactNode, useMemo } from 'react';
import { useAuthStore } from '../store/authStore';
import { decodeJWT } from '../lib/auth';

export function RequireOps({ children }: { children: ReactNode }) {
  const { token, isAuthenticated, hydrated } = useAuthStore();
  const hasOpsRole = useMemo(() => {
    if (!token) return false;
    const decoded = decodeJWT(token);
    const roles = decoded?.roles || (decoded?.role ? [decoded.role] : []);
    return roles.includes('ops') || roles.includes('admin');
  }, [token]);

  if (!hydrated) {
    return <div className="p-4 text-gray-600">Loading session...</div>;
  }

  if (!isAuthenticated) {
    return <div className="p-4 text-red-600">Authentication required</div>;
  }

  if (!hasOpsRole) {
    return (
      <div className="p-4">
        <h1 className="text-2xl font-bold mb-4">Access Restricted</h1>
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
          <div className="text-yellow-800">
            <strong>Access Denied:</strong> You need the "ops" or "admin" role to view this page.
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}


